export const operatorsMap = {
  form: [
    { text: 'is saved', value: 'formSaved', noValue: true },
    { text: 'is completed', value: 'formCompleted', noValue: true }
  ],
  button: [{ text: 'is clicked', value: 'IS CLICKED', noValue: true }],
  checked: [
    { text: 'is checked', value: 'IS CHECKED', noValue: true },
    { text: 'is not checked', value: 'IS NOT CHECKED', noValue: true }
  ],
  is: [
    { text: 'is', value: 'IS' },
    { text: 'is not', value: 'IS NOT' }
  ],
  null: [
    { text: 'is null', value: 'IS NULL', noValue: true },
    { text: 'is not null', value: 'IS NOT NULL', noValue: true }
  ],
  hasHave: [
    { text: "doesn't have all", value: 'DOES’T HAVE ALL' },
    { text: "doesn't have any", value: 'DOES’T HAVE ANY' },
    { text: 'has all', value: 'HAS ALL' },
    { text: 'has any', value: 'HAS ANY' }
  ],
  hasHaveDataLoader: [
    { text: "doesn't have all (applicable to multiselect dataloader fields)", value: 'DOES’T HAVE ALL' },
    { text: "doesn't have any (applicable to multiselect dataloader fields)", value: 'DOES’T HAVE ANY' },
    { text: 'has all (applicable to multiselect dataloader fields)', value: 'HAS ALL' },
    { text: 'has any (applicable to multiselect dataloader fields)', value: 'HAS ANY' }
  ],
  contain: [
    { text: 'contains', value: 'CONTAINS' },
    { text: 'does not contain', value: 'DOES NOT CONTAIN' }
  ],
  user: [
    { text: "is logged in user / is in current user's roles", value: 'IS LOGGED IN USER', noValue: true },
    { text: "is not logged in user / not in current user's roles", value: 'IS NOT LOGGED IN USER', noValue: true }
  ],
  number: [
    { text: 'is greater than', value: 'IS GREATER THAN' },
    { text: 'is smaller than', value: 'IS SMALLER THAN' }
  ],
  dateRange: [
    { text: 'between', value: 'BETWEEN' },
    { text: 'not between', value: 'NOT BETWEEN' }
  ],
  bulkImport: [
    { text: 'is', value: 'IS STEP COMPLETED' },
    { text: 'is not', value: 'IS STEP NOT COMPLETED' }
  ],
  validation: [
    { text: 'is valid', value: 'IS VALID', noValue: true },
    { text: 'is invalid', value: 'IS INVALID', noValue: true }
  ]
};
const operatorsWiseGroup = {
  numberFields: [...operatorsMap.is, ...operatorsMap.null, ...operatorsMap.number],
  textFields: [...operatorsMap.is, ...operatorsMap.null, ...operatorsMap.contain],
  dropdownFieldsAllOptions: [...operatorsMap.is, ...operatorsMap.null, ...operatorsMap.hasHave],
  dateRange: operatorsMap.dateRange
};
const getOperatorsBasedOnSelectType = (isMultiSelect) => {
  let operators = [...operatorsMap.is, ...operatorsMap.null];
  if (isMultiSelect) {
    return [...operators, ...operatorsMap.hasHave];
  }
  return operators;
};

const getOperatorsForDataLoaderFields = (isMultiSelect) => {
  let operators = [...operatorsMap.is, ...operatorsMap.null];
  if (isMultiSelect) {
    return [...operators, ...operatorsMap.hasHaveDataLoader];
  }
  return operators;
};

export const fieldWiseOperators = (isMultiSelect) => ({
  form: operatorsMap.form,
  checkbox: operatorsMap.checked,
  button: operatorsMap.button,
  CHECKBOX: operatorsWiseGroup.dropdownFieldsAllOptions,
  CURRENCY: operatorsWiseGroup.numberFields,
  DATE: [...operatorsWiseGroup.numberFields, ...operatorsWiseGroup.dateRange],
  DROPDOWN: getOperatorsBasedOnSelectType(isMultiSelect),
  EMAIL: operatorsWiseGroup.textFields,
  ENTITY: getOperatorsBasedOnSelectType(isMultiSelect),
  FILE_UPLOAD: operatorsMap.null,
  FORMULA: operatorsWiseGroup.textFields,
  LINK: operatorsWiseGroup.textFields,
  LIKERT: operatorsWiseGroup.numberFields,
  LONG_TEXT: operatorsWiseGroup.textFields,
  NUMBER: operatorsWiseGroup.numberFields,
  PHONE_NUMBER: operatorsWiseGroup.textFields,
  RADIO: [...operatorsMap.is, ...operatorsMap.checked],
  REFERENCE: [...getOperatorsBasedOnSelectType(isMultiSelect), ...operatorsMap.contain],
  SHORT_TEXT: operatorsWiseGroup.textFields,
  SLIDER: operatorsWiseGroup.numberFields,
  STAR_RATING: operatorsWiseGroup.numberFields,
  TAG: operatorsWiseGroup.dropdownFieldsAllOptions,
  USER: [...getOperatorsBasedOnSelectType(isMultiSelect), ...operatorsMap.user],
  BUSINESS_RULE: getOperatorsForDataLoaderFields(isMultiSelect),
  bulkImport: operatorsMap.bulkImport
});

export const BulkImportStatusMap = {
  'Data Upload': {
    STARTED: { key: 'Processing', value: 1 },
    FAILED: { key: 'Error', value: 2 },
    COMPLETED: { key: 'PartiallyCompleted', value: 3 }
  },
  'Data Mapper': {
    COMPLETED: { key: 'MappingSaved', value: 4 }
  },
  'Data Verification': {
    STARTED: { key: 'ExecutingValidations', value: 5 },
    FAILED: { key: 'ValidationsFailed', value: 6 },
    COMPLETED: { key: 'ValidationsExecuted', value: 7 }
  },
  'Data Import': {
    STARTED: { key: 'ExecutingImport', value: 8 },
    FAILED: { key: 'ImportFailed', value: 9 },
    COMPLETED: { key: 'Completed', value: 10 }
  }
};
